import React, { useState } from "react";
import { ReactComponent as GoldArrow } from "svgs/gold-arrow.svg";
import Link from "components/link";
import { useSettings } from "hooks/useStore";
import { trackNavClick } from "analytics";
import SubCategory from "./sub-category";

const CategoryMenu = ({ data }) => {
	const [activeIndex, setActiveIndex] = useState(0);
	const { toggleMenu } = useSettings(["toggleMenu"]);

	const handleOnLinkClick = (link) => {
		toggleMenu();
		trackNavClick(link.title);
	};

	const activateMenuItem = (index, title) => {
		setActiveIndex(index);
		trackNavClick(title);
	};

	return (
		<div className="py-4 px-6 flex flex-0 items-stretch mx-auto w-full standard-section-width">
			<div className="flex flex-col border-r border-gray pr-10">
				{data.map((link, index) => {
					if (!link || (link._type !== "link" && link._type !== "menuCategory")) {
						return null;
					}

					if (link._type === "link")
						// If the link is a direct link
						return (
							<Link
								to={link.url}
								key={`link_${index}`}
								onClick={() => handleOnLinkClick(link)}
								className="menu-category hover:underline"
							>
								{link.title}
							</Link>
						);

					if (link._type === "menuCategory" && !link.url)
						// If the link is a category
						return (
							<button
								className="menu-category"
								key={`category_${index}`}
								onClick={() => activateMenuItem(index, link.title)}
								onMouseOver={() => activateMenuItem(index, link.title)}
								onFocus={() => activateMenuItem(index, link.title)}
								aria-expanded={index === activeIndex}
								role="menuitem"
							>
								{link.title} {index === activeIndex && <GoldArrow />}
							</button>
						);

					if (link._type === "menuCategory" && link.url)
						// If the link is a category with a link
						return (
							<Link
								to={link.url}
								className="menu-category hover:underline"
								key={`category_${index}`}
								onClick={() => handleOnLinkClick(link)}
								onMouseOver={() => setActiveIndex(index)}
								onFocus={() => setActiveIndex(index)}
								aria-expanded={index === activeIndex}
								role="menuitem"
							>
								{link.title} {index === activeIndex && <GoldArrow />}
							</Link>
						);
				})}
			</div>
			{data?.[activeIndex]?._type !== "link" &&
				<SubCategory data={data[activeIndex]} activeCategory={activeIndex} />
			}
		</div>
	);
};

export default CategoryMenu;